export enum ViewMod {
    Home = 'home',
    Single = 'single',
    Chapters = 'chapters'
}